import { defineComponent as _defineComponent } from 'vue'
import { customersService } from '@/services/tenants.service';
import GenericKeyCopyModal from '@/components/GenericKeyCopyModal.vue';
import { onMounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DeviceSASModal',
  props: {
    customerId: null
  },
  emits: ['close'],
  setup(__props: any, { emit }) {

const props = __props as {
  customerId: number;
};





const loading = ref(false);
const sas = ref<string | null>(null);

onMounted(async () => {
  loading.value = true;
  try {
    sas.value = await customersService.getBlobStorageSAS(props.customerId);
  } catch (e) {
    emit('close');
  } finally {
    loading.value = false;
  }
});

return { __sfc: true,props, emit, loading, sas, GenericKeyCopyModal }
}

})